export default __webpack_public_path__ + "static/media/add_image.a51a1d99.svg";